import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Grid, Typography } from "@mui/material";
import { getInvoice, getInvoiceDownload } from "redux/actions/UserTrip";
import InvoiceMap from "./InvoiceMap";
import Loader from "components/loader/Loader";
import ArrowLineDown from "assets/images/ArrowLineDown.svg";
import { roleAndPermissionEnum } from "utils/rolesPermissionsEnum";
import { handlePermissions } from "utils/utils";
import { companyDetails } from "utils/companyDetails";
import LocationOnIcon from '@mui/icons-material/LocationOn';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';
import DescriptionIcon from '@mui/icons-material/Description';
import CheckIcon from '@mui/icons-material/Check';

function InvoiceDetails() {
  const {id, magicToken} = useParams()
  const dispatch = useDispatch();
  const {state} = useLocation();
  const tripDetails = useSelector((state) => state?.userInvoice?.userInvoice?.data);
  const loader = useSelector((state) => state?.userInvoice?.loading);
  const downloadLoader = useSelector((state) => state?.userInvoiceDownload?.loading);
  const invoiceId = state?.id;
  const tripId = state?.tripId;
  const filterData = {
    id: id ? id : invoiceId,
    status: '',
    page: '',
    pageSize: '',
    date: '',
    type: '',
    magicToken:magicToken || ''
  };

  useEffect(() => {
    dispatch(getInvoice(filterData));
  }, []);

  const onDownload = () => {
    const downloadData = {
      id:invoiceId || tripDetails?.id
    }
    dispatch(getInvoiceDownload(downloadData))
  }
//roles and permissions
const roleAndPermissions = useSelector(
  (state) => state?.getRolesAndPermissions?.rolesAndPermissions
);
const invoiceRoleEnum =
  roleAndPermissionEnum.invoice;

const accessForall = handlePermissions(
  roleAndPermissions,
  invoiceRoleEnum.moduleKey,
  { defaultAllAccess: invoiceRoleEnum?.all }
);

const accessForDownload = handlePermissions(
  roleAndPermissions,
  invoiceRoleEnum.moduleKey,
  { customAccess: invoiceRoleEnum?.download }
);

const downloadAccess = (accessForall || accessForDownload)

  return (
    <Grid>
      <Grid
        container
        direction="row"
        justifyContent="space-between"
        alignItems="center"
      >
        { magicToken ? 
          <Grid item style={{ flex: 1, minWidth: 0 }}>
            {loader ? '' : 
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'nowrap', gap: 12 }}>
              {/* Left: Logo + Company Info */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                <img src={companyDetails?.companyLogo} alt="Logo" width="240" height="240" style={{ height: 'clamp(70px, 10vw, 120px)', width: 'clamp(70px, 10vw, 120px)', flexShrink: 0, imageRendering: 'auto' }} />
                <div style={{ minWidth: 0 }}>
                  <Typography className="fontMedium colorPrimary" style={{ marginBottom: 4, fontSize: 'clamp(16px, 2.2vw, 22px)', whiteSpace: 'nowrap' }}>{tripDetails?.companyName}</Typography>
                  {tripDetails?.companyAddress && (
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 4, marginBottom: 3 }}>
                      <LocationOnIcon sx={{ color: '#0f538d', fontSize: 'clamp(12px, 1.5vw, 18px)', marginTop: '2px', flexShrink: 0 }} />
                      <Typography style={{ fontSize: 'clamp(12px, 1.5vw, 16px)' }}>{tripDetails?.companyAddress}</Typography>
                    </div>
                  )}
                  {tripDetails?.supportEmail && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, marginBottom: 3 }}>
                      <EmailIcon sx={{ color: '#0f538dff', fontSize: 'clamp(12px, 1.5vw, 16px)', flexShrink: 0 }} />
                      <Typography style={{ fontSize: 'clamp(12px, 1.5vw, 16px)' }}>{tripDetails?.supportEmail}</Typography>
                    </div>
                  )}
                  {tripDetails?.supportPhone && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                      <PhoneIcon sx={{ color: '#0f538d', fontSize: 'clamp(12px, 1.5vw, 16px)', flexShrink: 0 }} />
                      <Typography style={{ fontSize: 'clamp(12px, 1.5vw, 16px)' }}>{tripDetails?.supportPhone}</Typography>
                    </div>
                  )}
                </div>
              </div>
              {/* Divider + GST Box */}
              {tripDetails?.gstNumber && (
                <div style={{ display: 'flex', alignItems: 'center', gap: 16, flexShrink: 0, marginLeft: -8, marginRight: 12 }}>
                  <div style={{ width: 1, height: 50, backgroundColor: '#e0e0e0' }} />
                <div style={{ border: '1px solid #e0e0e0', borderRadius: 6, padding: '4px 8px', display: 'flex', alignItems: 'center', gap: 6, backgroundColor: '#f5f5f5' }}>
                  <div style={{ backgroundColor: '#0f538dff', borderRadius: '50%', padding: 4, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <DescriptionIcon sx={{ color: '#ffffff', fontSize: 16 }} />
                  </div>
                  <div>
                    <Typography style={{ fontSize: 10, color: '#000', lineHeight: 1.2 }}>GST No.</Typography>
                    <Typography className="fontMedium" style={{ fontSize: 12, whiteSpace: 'nowrap', lineHeight: 1.3 }}>{tripDetails?.gstNumber}</Typography>
                  </div>
                </div>
                </div>
              )}
            </div>}
          </Grid>
          :
          <Grid item md={10} className="margin10">
            {loader ? '' : <Typography className="font28 fontMedium">
              Trip {" "+tripDetails?.tripId}  <span className="completeText" style={{ display: 'inline-flex', alignItems: 'center', gap: 6, borderRadius: 10, padding: '4px 10px' }}><span style={{ display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: 22, height: 22, backgroundColor: '#fff', borderRadius: '50%' }}><CheckIcon sx={{ color: '#000', fontSize: 16 }} /></span>{tripDetails?.status || ''}</span>
            </Typography>}
          </Grid>
        }
        {!magicToken && downloadAccess &&<Grid item md={1.5}>
          <Button className="btnSubvendor" onClick={() => onDownload()} disabled={downloadLoader}>
            {downloadLoader ? 'Loading...' : 'Download'}
            <img src={ArrowLineDown} alt="ArrowLineDown" />
          </Button>
        </Grid>}
      </Grid>
      {loader? 
        <Loader/> 
        :
      <Grid className="invoiceMap">
        <InvoiceMap tripDetails={tripDetails} magicToken={magicToken} />
      </Grid>}
    </Grid>
  );
}

export default InvoiceDetails;
